import { WorkOutlineOutlined as WorkOutlineOutlinedIcon } from '@mui/icons-material';
import { Badge } from '../badge';
import { Avatar, AvatarProps } from './Avatar';

const ContainerAvatarBase: React.FC<AvatarProps> = ({ ...props }: AvatarProps) => {
  return (
    <Avatar data-size={props['data-size'] || 'small'} button={true} {...props}>
      <WorkOutlineOutlinedIcon />
    </Avatar>
  );
};

interface ContainerAvatarProps {
  images: { url: string }[];
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
}

export const ContainerAvatar: React.FC<ContainerAvatarProps> = ({
  images,
  onClick,
  size = 'small',
}: ContainerAvatarProps) => {
  if (images.length > 1)
    return (
      <Badge badgeContent={images.length} data-size={'small'} overlap={'circular'}>
        <ContainerAvatarBase src={images[0].url} onClick={onClick} data-size={size} />
      </Badge>
    );

  if (images.length === 1)
    return <ContainerAvatarBase src={images[0].url} onClick={onClick} data-size={size} />;

  return <ContainerAvatarBase onClick={onClick} data-size={size} />;
};
